var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page"},[_c('h1',[_vm._v("Payment Successful!")]),_c('p',[_vm._v("Thank you for your purchase. Please check your email for further instructions.")]),_c('button',{staticClass:"home-button",on:{"click":_vm.goToHome}},[_vm._v("Return to Home")])])
}
var staticRenderFns = []

export { render, staticRenderFns }